/**
 * @file JobBodyExtraInfoSlot.tsx
 *
 * @fileoverview This component renders aditional terms to the all terms section of the job
 */
import { Slottable } from '~/jobiqo/components/Slots/interfaces';
import { Job } from '~/jobiqo/types/types';

interface JobAllTermsSlotProps {
  /**
   * The job entity.
   */
  job: Slottable<Job>;
}

export default function JobAllTermsSlot({ job }: JobAllTermsSlotProps) {
  return null;
}
export { JobAllTermsSlot };
